import { createSlice /*createAsyncThunk*/ } from "@reduxjs/toolkit";
// import queryString from "query-string";
// import settings from "./settings";
// import { fetchData } from "./utils";

// const { baseApiUrl, apiAuthToken } = settings;

// const apiHeaders = {
//   Authorization: `Token ${apiAuthToken}`,
//   "Content-Type": "application/json",
// };

// export const getRecommendations = function (userId, args = {}) {
//   if (userId === "NA") {
//     return Promise.resolve({ error: "user id not valid" });
//   }

//   let query = {
//     user_id: 50000039,
//     top_n: 20,
//     fields: "display_name",
//     product_type: "recommended",
//     ...args,
//   };

//   const q = queryString.stringify(query);
//   const url = `${baseApiUrl}/api/users/recommendations/`;

//   return fetchData(`${url}?${q}`, apiHeaders).catch(() => {
//     query.product_type = "popular";
//     const q = queryString.stringify(query);
//     return fetchData(`${url}?${q}`, apiHeaders);
//   });
// };

// export const fetchRecommendations = createAsyncThunk(
//   "recommendations/fetchRecommendations",
//   async ({ userId }, { getState, dispatch, extra }) => {
//     const recommendations = await getRecommendations(userId);
//     return recommendations;
//   }
// );

// export const recommendationsSlice = createSlice({
//   name: "recommendations",
//   initialState: {
//     requests: {
//       fetchRecommendations: {},
//     },
//     entities: [],
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder.addCase(fetchRecommendations.fulfilled, (state, action) => {
//       const { results } = action.payload;
//       state.entities = results;
//     });
//     // builder.addCase(fetchRecommendations.pending, (state, action) => {
//     //   const key = queryString.stringify(action.meta.arg);
//     //   state.requests.fetchRecommendations[key] = "pending";
//     // });
//   },
// });

export const widgetsSlice = createSlice({
  name: "widgets",
  initialState: {},
  reducers: {
    updateWidget(state, action) {
      const { widgetId, properties } = action.payload;
      state[widgetId] = { ...state[widgetId], ...properties };
    },
  },
});

export const { updateWidget } = widgetsSlice.actions;

export const userSlice = createSlice({
  name: "user",
  initialState: null,
  reducers: {
    updateUser(state, action) {
      return action.payload;
    },
    // updateIsLoggedIn(state, action) {
    //   state.isLoggedIn = action.payload;
    // },
  },
});

export const { updateUser } = userSlice.actions;

// export const authSlice = createSlice({
//   name: "auth",
//   initialState: { authToken: null },
//   reducers: {
//     setAuthToken: (state, action) => {
//       state.authToken = action.payload.token;
//     },
//   },
// });

// export const { setAuthToken } = authSlice.actions;

// export const getAuthToken = (state) => state.auth.authToken;
